import { useSettingLoggedOutHomepageRedesignV2 } from "@faire/retailer-visitor-shared/settings/useSettingLoggedOutHomepageRedesignV2";
import { BottomSignUpBannerContent } from "@faire/retailer-visitor-shared/views/home/logged-out-homepage/__internal__/components/BottomSignUpBanner/__internal__/BottomSignUpBannerContent/BottomSignUpBannerContent";
import { BottomSignUpBannerImages } from "@faire/retailer-visitor-shared/views/home/logged-out-homepage/__internal__/components/BottomSignUpBanner/__internal__/BottomSignUpBannerImages";
import { MoreToExplorePills } from "@faire/retailer-visitor-shared/views/home/logged-out-homepage/__internal__/components/BottomSignUpBanner/__internal__/MoreToExplorePills/MoreToExplorePills";
import { Column } from "@faire/web--source/slate/Layout";
import { useDoActionWhenVisible } from "@faire/web--source/ui/hooks/useDoActionWhenVisible";
import { WhenVisibilityIsImminent } from "@faire/web--source/ui/VisibilitySensor/WhenVisibilityIsImminent";
import { trackLoggedOutRetailersLoggedOutHomeRedesignView } from "@faire/web-api--source/events/loggedOutRetailers/view/loggedOutHomeRedesign";
import React from "react";

export const BottomSignUpBanner: React.FC = () => {
  const homepageRedesignVariant = useSettingLoggedOutHomepageRedesignV2();
  const ref = useDoActionWhenVisible(() =>
    trackLoggedOutRetailersLoggedOutHomeRedesignView(
      "perfect_product_banner",
      `${homepageRedesignVariant}`
    )
  );
  return (
    <Column
      className="w-full h-full bg-[#ffd0b6] pb-6 pt-14 md:pt-0 md:h-auto"
      align="center"
      justify={{ mobileAndAbove: "end", tabletAndAbove: "center" }}
      data-test-id="bottom-sign-up-banner"
      gap="4x"
      ref={ref}
    >
      <BottomSignUpBannerImages />
      <BottomSignUpBannerContent />
      <WhenVisibilityIsImminent>
        <MoreToExplorePills />
      </WhenVisibilityIsImminent>
    </Column>
  );
};
